export function addTitleToIcon(icon: SVGElement, title = 'Icon Title'): SVGElement {
  addRoleImgToIcon(icon);
  const titleElement = document.createElementNS('http://www.w3.org/2000/svg', 'title');
  titleElement.textContent = title;
  icon.prepend(titleElement);
  icon.setAttribute('aria-label', title);
  return icon;
}

export function addLabeledbyToIcon(icon: SVGElement, describedById: string) {
  addRoleImgToIcon(icon);
  icon.setAttribute('aria-labelledby', describedById);
  return icon;
}

export function addPresentationToIcon(icon: SVGElement) {
  icon.setAttribute('role', 'presentation');
  return icon;
}

function addRoleImgToIcon(icon: SVGElement) {
  icon.setAttribute('role', 'img');
  return icon;
}
